<div class="relative flex h-full flex-col">
  @if (isUserAdmin()) {
    <div
      class="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-neutral-100 opacity-70"
      style="z-index: 10"
    >
      <span class="text-md font-semibold text-gray-800">Admin user have full permissions to everything.</span>
    </div>
  }

  <!-- Search and Apply Changes Controls -->
  <div class="align-center flex justify-end gap-2 border-b border-gray-300 p-3 dark:border-gray-700">
    <dojo-text-input [formCtrl]="searchCtrl()" placeholder="Search permissions..." [size]="'s'" class="max-w-sm">
      <dojo-icon icon="magnifying-glass" y42InputPrefix />
    </dojo-text-input>
    <dojo-button
      [size]="'xs'"
      [disabled]="isFormPristine()"
      [pending]="isSaving()"
      [customColor]="'sky'"
      (click)="onSaveClick()"
    >
      <dojo-icon icon="save" class="mr-1" />
      Apply Role Changes
    </dojo-button>
  </div>

  <!-- AG-Grid -->
  <div class="flex-1">
    <dojo-master-list-view
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [agGridAdditionalClass]="'small-height'"
      [hideSearch]="true"
      class="review-permissions-list-view h-full"
      [showToolbarAddButton]="false"
      (gridReady)="onGridReady($event)"
      [hideNumberOfEntries]="true"
      [canAdd]="false"
    />
  </div>
</div>
